<payee-popup title="Szolgáltatás törlése">
  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      (click)="submit()"
    >
      Törlés
    </button>
  </ng-template>
  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="alert-red"
      width="max"
      mat-dialog-close
    >
      Mégse
    </button>
  </ng-template>
</payee-popup>
